import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogHeaderWithClose from '../basic/DialogHeaderWithClose';
import Button from '../basic/Button';

const useStyles = (theme) => ({
  dialogContentScroll: {
    overflowY: 'auto',
  },
  dialogContent: {
    maxHeight: 'unset',
  },
});

const DialogInputNew = (props) => {
  const classes = useStyles();
  const { open, handleClose, contentStyle, className, title, children, actions, sx, titleClass, noCancel, ...rest } = props;

  const dialogStyles = {
    maxWidth: 'unset',
    position: 'absolute',
    ...contentStyle
  };

  return (
    <Dialog
      sx={{
        '& .MuiDialog-paper': {
          ...dialogStyles,
        },
        ...sx,  // You can pass additional styles via sx prop if needed
      }}
      className={`dialog ${className || ``}`}
      open={open}
      onClose={handleClose}
      {...rest} // Pass any remaining props to the Dialog component
    >
      {title && (
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <DialogHeaderWithClose text={title} handleClose={handleClose} classicClass={titleClass} noCancel />
        </DialogTitle>
      )}
      <DialogContent style={classes.dialogContent}>
        {children}
      </DialogContent>
      {actions && (
        <DialogActions>
          {!noCancel && <Button
              key={1}
              name="CancelButton"
              label="Cancel"
              primary={true}
              className="btn-space btnCancel"
              onTouchTap={handleClose}
          />}
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default DialogInputNew;